import { Button, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import type { FC } from "react";

type Props = {
	label: string;
	onClick: () => void;
};

export const AddRowButton: FC<Props> = ({ label, onClick }) => {
	const theme = useTheme();

	return (
		<Button variant="addRow" disableRipple onClick={onClick}>
			<Plus size={theme.iconSize.sm} />
			{label}
		</Button>
	);
};
